// extracted by mini-css-extract-plugin
module.exports = {"highCpu":"FieldsAvailabilityZoneByFlavor__highCpu--2mJqw","hint":"FieldsAvailabilityZoneByFlavor__hint--ynjIT"};